var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShoppingCart = function SvgShoppingCart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.588,
    height: 16.5,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1B1B1B",
    fillRule: "evenodd",
    d: "M6.794 0a3.88 3.88 0 0 0-3.882 3.882H0V14.56C0 15.63.87 16.5 1.941 16.5h9.706c1.072 0 1.941-.87 1.941-1.941V3.883h-2.912A3.88 3.88 0 0 0 6.794 0m2.912 3.882q0-1.206-.853-2.059Q8 .971 6.794.971t-2.059.852-.853 2.06zm2.912.971H.97v9.706q0 .402.284.686t.686.284h9.706q.402 0 .686-.284t.284-.686z"
  })));
};
export default SvgShoppingCart;